import { mount } from '../../../js/dom-lifecycle';

mount('[data-select-type="select2"]', function () {
    const $select = $(this);
    $select.select2({
        width: '100%',
        placeholder: $select.attr('data-placeholder'),
        closeOnSelect: true,
        dropdownParent: $select.closest('.modal')
    });
});

mount('[data-filter-on-change="true"]', function () {
    const $master = $(this);
    const $target = $('[data-to-filter="true"]');
    const items = [];

    $target.find('option').each(function () {
        if ($(this).val()) {
            items.push({
                id: $(this).val(),
                text: $(this).text(),
                type: $(this).attr('data-type'),
                description: $(this).attr('data-description'),
            });
        }
    });

    $master.on('change', function () {
        const type = $(this).val();
        const filtered = items.filter(item => item.type === type);
        $target.find('option').remove();
        $target.append('<option value=""></option>');
        $target.append(filtered.map(item =>
            `<option value="${item.id}" data-description="${item.description}">${item.text}</option>`
        ).join(''));
    });
});

mount('[data-go-to-selected]', function () {
    $(this).on('click', function () {
        const value = $($(this).data('go-to-selected')).val();
        if (value) window.location = value;
    });
});

mount('#page-type-select, #page-subtype-select', function () {
    $(this).on('change', function () {
        const descriptionTarget = $(this).find(':selected').attr('data-description');
        if (descriptionTarget) {
            $('.page-type-label-container').addClass('d-none');
            $(descriptionTarget).removeClass('d-none');
        }
    });
});
